<template>
  <div>
    <section class="hero is-dark">
      <div class="hero-body">
        <div class="container">
          <div class="columns">
            <div class="column">
              <h1 class="title">Crear Nuevo Usuario</h1>
              <h2 class="subtitle">
                Crea los usuarios que pueden acceder a app siete
              </h2>
            </div>
            <div class="column has-text-right">
              <router-link
                :to="{ name: 'usermenu' }"
                class="button is-medium is-light"
              >
                Volver a Usuarios
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section">
      <div class="container">
        <div class="field fieldUserType">
          <div class="fieldsub">
            <span style="font-size:20px;color:#49007A">
              Seleccionar tipo de usuario:</span
            >
          </div>
          <div class="columns is-multiline">
            <div class="column is-2">
              <input
                v-model="user.claims.admin"
                class="is-checkradio is-dark"
                id="ch"
                type="checkbox"
                name="ch"
              />
              <label for="ch" style="font-size:20px;">Admin Siete</label>
            </div>
            <div class="column is-2">
              <input
                v-model="user.claims.cliente"
                :disabled="user.claims.admin"
                class="is-checkradio is-dark"
                id="ch2"
                type="checkbox"
                name="ch2"
              />
              <label for="ch2" style="font-size:20px;">Cliente</label>
            </div>
          </div>
        </div>
      </div>
      <div v-if="user.claims.cliente" class="container">
        <div class="field fieldUserType">
          <div class="fieldsub">
            <span> Seleccionar opciones de usuario cliente:</span>
          </div>
          <div class="columns is-multiline">
            <div class="column is-2">
              <input
                v-model="user.claims.frs"
                :disabled="user.claims.admin"
                class="is-checkradio is-dark"
                id="ch3"
                type="checkbox"
                name="ch3"
              />
              <label for="ch3">Factores</label>
            </div>
          </div>
        </div>
      </div>
      <div v-if="user.claims.cliente" class="container">
        <div class="field fieldUserType">
          <div class="fieldsub">
            <span class="has-text-dark"> Roles de Factores de riesgo</span>
          </div>
          <div class="columns is-multiline">
            <div class="column is-3">
              <input
                v-model="user.claims.frp"
                :disabled="user.claims.admin"
                class="is-checkradio is-dark"
                id="ch9"
                type="checkbox"
                name="ch9"
              />
              <label for="ch9">Factores Nuevo</label>
            </div>
          </div>
        </div>
      </div>
      <div v-if="user.claims.cliente" class="container">
        <div class="field fieldUserType">
          <div class="fieldsub">
            <span class="has-text-dark"> Roles de Liderazgo</span>
          </div>
          <div class="columns is-multiline">
            <div class="column is-2">
              <input
                v-model="user.claims.lider"
                :disabled="user.claims.admin"
                class="is-checkradio is-dark"
                id="ch4"
                type="checkbox"
                name="ch4"
              />
              <label for="ch4">Líder Admin</label>
            </div>
            <div class="column is-2">
              <input
                v-model="user.claims.liderl"
                :disabled="user.claims.admin"
                class="is-checkradio is-dark"
                id="ch5"
                type="checkbox"
                name="ch5"
              />
              <label for="ch5">Evaluado</label>
            </div>
            <div class="column is-2">
              <input
                v-model="user.claims.ghumana"
                :disabled="user.claims.admin"
                class="is-checkradio is-dark"
                id="ch6"
                type="checkbox"
                name="ch6"
              />
              <label for="ch6">G. Humana</label>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="field fieldUserType">
          <div class="fieldsub">
            <span class="has-text-dark"> Roles de CL7</span>
          </div>
          <div class="columns is-multiline">
            <!--<div class="column is-2">
              <input
                  v-model="user.claims.gcl7"
                  class="is-checkradio is-dark"
                  id="ch7"
                  type="checkbox"
                  name="ch7"
              />
              <label for="gcl7">G. Cl7</label>
            </div>-->
            <div class="column is-2">
              <input
                v-model="user.claims.free"
                :disabled="user.claims.admin"
                class="is-checkradio is-dark"
                id="ch8"
                type="checkbox"
                name="ch8"
              />
              <label for="ch8">G. Cl7</label>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <section class="margin-top">
          <div class="field">
            <div class="control has-icons-left">
              <input
                class="input is-large"
                type="text"
                placeholder="Nombre"
                v-model="user.displayName"
              />
              <span class="icon is-medium is-left">
                <i class="material-icons">person</i>
              </span>
            </div>
          </div>
          <div class="field">
            <div class="control has-icons-left">
              <input
                class="input is-large"
                type="email"
                placeholder="Correo"
                v-model="user.email"
              />
              <span class="icon is-medium is-left">
                <i class="material-icons">email</i>
              </span>
            </div>
          </div>
          <div class="field">
            <div class="fieldsub">
              <span style="font-size:20px;color:#49007A">
                Seleccionar Empresa:</span
              >
            </div>
            <p class="control has-icons-left">
              <!-- <span class="select is-large is-fullwidth">
                <select v-model="current">
                  <option
                    v-for="option in empresas"
                    v-bind:value="option"
                    v-bind:key="option._id"
                  >{{ option.nombre }} {{option.nit}}</option>
                </select>

              </span> -->
              <!-- select de vue
              <h1>Vue Select</h1>
              <v-select :options="empresas"></v-select> -->
              <!-- <v-select v-model="selected" :options="['Canada','United States']" /> -->

              <span class=" is-large is-fullwidth">
                <v-select
                  label="nombre"
                  :options="empresas"
                  v-model="current"
                  placeholder="Seleccione una empresa"
                ></v-select>
              </span>

              <!-- <span class="icon is-small is-left">
                <i class="material-icons">location_city</i>
              </span> -->
            </p>
          </div>
          <!-- <div class="field is-grouped">
            <div class="control">
              <button class="button is-info is-large" @click="enviar">Enviar</button>
            </div>
            <div class="control">
              <button class="button is-large" @click="borrar">Cancelar</button>
            </div>
          </div> -->
          <div class="buttons">
            <!-- <router-link
              class="button is-large is-light"
              :to="{ name: 'empresas' }"
            >
              <span @click="borrar">
                <small>Cancelar</small>
              </span>
            </router-link> -->
            <router-link
              :to="{ name: 'usermenu' }"
              class="button is-large is-light"
            >
              Cancelar
            </router-link>
            <button class="button is-large is-dark" @click="enviar">
              Guardar
            </button>
          </div>
        </section>
      </div>
      <br />
      <button
        v-if="user.claims.liderl"
        class="button is-info"
        @click="traeempleados()"
      >
        Traer Empleados
      </button>
      <section v-if="user.claims.liderl" class="section">
        <div class="field is-centered is-grouped">
          <p class="control has-icons-left has-icons-right">
            <input
              class="input is-normal is-focused"
              type="text"
              v-model="search"
              placeholder="Buscar Empleado"
            />
            <span class="icon is-medium is-left">
              <i class="material-icons">search</i>
            </span>
          </p>
        </div>
        <table class="table">
          <tr>
            <th></th>
            <th>Correo</th>
            <th>Nombre</th>
            <th>Cargo</th>
            <th>Dependencia</th>
            <th>Controles</th>
          </tr>
          <tr v-for="(k, v) in filteredItems" :key="v">
            <td>{{ v + 1 }}</td>
            <td>{{ k.email }}</td>
            <td>{{ k.nombre }}</td>
            <td>{{ k.cargo }}</td>
            <td>{{ k.dependencia }}</td>
            <td>
              <button class="button is-info" @click="seleccionar(k)">
                Seleccionar
              </button>
            </td>
          </tr>
        </table>
      </section>
    </section>
  </div>
</template>

<script>
import apiServices from "@/services/yungol-services";
import { mapState } from "vuex";
import Vue from "vue";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

Vue.component("v-select", vSelect);

const filterItems = (query, data) => {
  return data.filter((el) => {
    const texto = el.email + el.nombre + el.cargo + el.dependencia + el.proceso;
    if (texto.toLowerCase().indexOf(query.toLowerCase()) > -1) {
      return el;
    }
  });
};
export default {
  data() {
    return {
      user: {
        currentCompany: "",
        companys: {},
        claims: {},
      },
      empresas: [],
      current: "",
      search: "",
      listempleados: [],
    };
  },
  computed: {
    ...mapState(["idtoken"]),
    filteredItems: function() {
      return filterItems(this.search, this.listempleados);
    },
  },
  methods: {
    seleccionar(d) {
      this.user.empleado = d._id;
    },
    borrar() {
      this.nombre = "";
      this.valor = "";
    },
    async enviar() {
      let result;

      if (
        (this.user.claims.admin || this.user.claims.cliente) &&
        this.current._id &&
        this.user.displayName &&
        this.user.email
      ) {
        try {
          this.user.currentCompany = this.current._id;
          this.user.companys = {};
          this.user.companys[this.current._id] = {
            id: this.current._id,
          };
          result = await apiServices.post(`/users`, this.user);
          await this.$auth.sendPasswordResetEmail(this.user.email);
          if (result) {
            this.$store.dispatch("notify", {
              message: `Perfecto. Usuario creado con éxito`,
            });
            this.user.displayName = "";
            this.user.email = "";
            this.current = "";
            this.claims = {};
          }
        } catch (error) {
          console.log(error);
          this.$store.dispatch("notify", {
            message: "Ups, ocurrió un error. Inténtelo nuevamente",
            type: "is-danger",
            duration: 4000,
          });
        }
      } else {
        let mess;
        if (!(this.user.claims.admin || this.user.claims.cliente))
          mess = "Selecciona por favor tipo de usuario";
        else if (!this.user.displayName) mess = "Ingresa nombre de usuario";
        else if (!this.user.email) mess = "Ingresa correo de usuario";
        else if (!this.current._id)
          mess = "Selecciona una empresa para el usuario";

        this.$store.dispatch("notify", {
          message: mess,
          type: "is-danger",
          duration: 4000,
        });
      }
    },
    async traeempleados() {
      this.listempleados = [];
      let result;
      try {
        result = await apiServices.get(`/listliderempleados/cpy`);
        if (result.data) {
          this.listempleados = result.data;
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
  mounted: function() {
    async function enviar(_this) {
      let result;
      const d = {
        _id: "",
        nombre: "",
        nit: "",
      };
      try {
        result = await apiServices.get(`/empresas`);
        _this.empresas = [].concat([d], result.data);
        _this.empresas.sort((a, b) => a.nombre.localeCompare(b.nombre));
        console.log(_this.empresas);
        // _this.current = d;
      } catch (error) {
        console.log(error);
      }
    }

    enviar(this);
  },
  watch: {
    "user.claims": {
      handler(newValue) {
        if (newValue.admin) {
          Object.keys(newValue).map((x) => {
            if (x !== "admin") {
              this.user.claims[x] = false;
            }
          });
        }
      },
      deep: true,
    },
  },
  components: {
    vSelect,
  },
};
</script>

<style lang="scss" scoped>
.is-checkradio[type="radio"]:checked + label::before,
.is-checkradio[type="radio"]:checked + label:before,
.is-checkradio[type="checkbox"]:checked + label::before,
.is-checkradio[type="checkbox"]:checked + label:before {
  border: 0.15rem solid #dbdbdb;
}

.is-checkradio[type="checkbox"] + label::after,
.is-checkradio[type="checkbox"] + label:after {
  border-width: 0.15rem;
}

.fieldUserType {
  margin-top: 20px;
  margin-bottom: 25px;
}

.fieldsub {
  margin-top: 5px;
  margin-bottom: 10px;
}

.fieldsub span {
  font-weight: bold;
}

.mainContent {
  padding: 0px 60px;
}

.style-chooser .vs__search::placeholder,
.style-chooser .vs__dropdown-toggle,
.style-chooser .vs__dropdown-menu {
  background: #dfe5fb;
  border: none;
  color: #394066;
  text-transform: lowercase;
  font-variant: small-caps;
}

.style-chooser .vs__clear,
.style-chooser .vs__open-indicator {
  fill: #394066;
}
</style>



// WEBPACK FOOTER //
// src/components/users/AddUser.vue